var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10 10 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/video/stop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.8,
    className: "svg-stroke",
    stroke: "#FFFFFF",
    strokeWidth: 1.3,
    cx: 25,
    cy: 25,
    r: 14.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 18.000000)",
    className: "svg-fill",
    fill: "#FFFFFF",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38888889,0 L4.94444444,0 C4.66830207,5.07265313e-17 4.44444444,0.223857625 4.44444444,0.5 C4.44444444,0.636139833 4.44444444,0.772279665 4.44444444,0.908419498 L4.44444444,7.48892171 L4.44444444,14.0915805 C4.44444444,14.2277203 4.44444444,14.3638602 4.44444444,14.5 C4.44444444,14.7761424 4.66830207,15 4.94444444,15 L5.38888889,15 C5.66503126,15 5.88888889,14.7761424 5.88888889,14.5 C5.88888889,14.3638602 5.88888889,14.2277203 5.88888889,14.0915805 L5.88888889,0.908419498 C5.88888889,0.772279665 5.88888889,0.636139833 5.88888889,0.5 C5.88888889,0.223857625 5.66503126,-5.07265313e-17 5.38888889,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.944444444,0 L0.5,0 C0.223857625,5.07265313e-17 3.23374149e-13,0.223857625 3.23407967e-13,0.5 C3.23407967e-13,0.636139833 3.23407967e-13,0.772279665 3.23407967e-13,0.908419498 L3.23407967e-13,7.48892171 L3.23407967e-13,14.0915805 C3.23407967e-13,14.2277203 3.23407967e-13,14.3638602 3.23407967e-13,14.5 C3.24311817e-13,14.7761424 0.223857625,15 0.5,15 L0.944444444,15 C1.22058682,15 1.44444444,14.7761424 1.44444444,14.5 C1.44444444,14.3638602 1.44444444,14.2277203 1.44444444,14.0915805 L1.44444444,0.908419498 C1.44444444,0.772279665 1.44444444,0.636139833 1.44444444,0.5 C1.44444444,0.223857625 1.22058682,-5.07265313e-17 0.944444444,0 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f2ca540420e111880e87d3ba720e4932.svg";
export { ForwardRef as ReactComponent };